<template>
  <!-- 거래 내역 -->
  <div class="detail-dropdown-box list">
    <div class="header">
      <div class="tit">{{ /*거래내역*/ $t("PCOP-02-02-04-19") }}</div>
      <i class="icon icon-dropdown-m-arrow" :class="{ rotate: !show4 }" @click="show4 = !show4" />
    </div>
    <div class="content" v-if="show4">
      <!-- 계좌간이체 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110010">
        <div class="sub-tit">{{ /*출금정보*/ $t("PCOP-02-03-05-18") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-01-07") }}</dt>
          <dd>
            {{ RCA040FA40Response.drwotAcno }}
            {{ RCA040FA40Response.trsaccDrwotAcnAls && `(${RCA040FA40Response.trsaccDrwotAcnAls})` }}
          </dd>
          <dt>{{ /*이체금액*/ $t("PCOP-02-03-01-08") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.trsaccAmt) }}</dd>
          <dt>{{ /*수수료*/ $t("PCOP-02-03-01-09") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.fee) }}</dd>
          <dt>{{ /*송금메모*/ $t("PCOP-02-03-01-10") }}</dt>
          <dd>{{ RCA040FA40Response.rmtancMemoCtnt }}</dd>
        </dl>
        <div class="sub-tit">{{ /*입금정보*/ $t("PCOP-02-03-05-19") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*입금계좌번호*/ $t("PCOP-02-03-01-12") }}</dt>
          <dd>
            {{ RCA040FA40Response.mnrcvAcno }}
            {{ RCA040FA40Response.trsaccMnrcvAcnAls && `(${RCA040FA40Response.trsaccMnrcvAcnAls})` }}
          </dd>
          <dt>{{ /*수취인*/ $t("PCOP-02-03-01-13") }}</dt>
          <dd>{{ RCA040FA40Response.ovsesTrsaccDraweFname }}</dd>
          <dt>{{ /*수취인 참조내용*/ $t("PCOP-02-03-01-14") }}</dt>
          <dd>{{ RCA040FA40Response.draweBnkbkRepsntCtnt }}</dd>
        </dl>
      </template>
      <!--다계좌 이체-->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110020">
        <dl class="dlist dlist-item--type4">
          <dt>{{ $t(/*출금계좌번호*/ "PCOP-02-03-02-06") }}</dt>
          <dd>{{ RCA040FA40Response.dataGrid[0].drwotAcno }}</dd>
          <dt>{{ /*총 이체금액*/ $t("PCOP-02-03-02-07") }}</dt>
          <dd>{{ RCA040FA40Response.currencyCode }} {{ $num(RCA040FA40Response.dTotalTrsaccAmt) }}</dd>
          <dt>{{ /*수수료*/ $t("PCOP-02-03-02-12") }}</dt>
          <dd>{{ RCA040FA40Response.currencyCode }} {{ $num(RCA040FA40Response.dTotalFeeAmt) }}</dd>
        </dl>
        <div class="sub-tit">{{ /*이체결과*/ $t("PCOP-02-03-02-09") }}</div>
        <!-- 이체 결과 부분-->
        <template v-for="(list, index) in RCA040FA40Response.dataGrid">
          <div class="box-white -type4" :key="index">
            <div class="header">
              <div class="title">
                {{ list.mnrcvAcno }}({{ list.cncycd }})
                <!--처리 상태-->
                <template v-if="list.corpBsacRiStusDstcd == '1' && list.prcssStusDstcd == '1'">
                  <template v-if="list.iBTelgmPrcssRsultCd == '0000'">
                    <div class="state normal">{{ /*정상*/ $t("PCOP-02-03-02-10") }}</div>
                  </template>
                  <template v-else>
                    <div class="state warning">{{ /*실패*/ $t("PCOP-02-03-02-20") }}</div>
                  </template>
                </template>
                <!--처리상태 END-->
              </div>
              <div class="desc">
                <div class="item account">{{ list.draweCustnm }}</div>
              </div>
            </div>
            <div class="content">
              <div class="account-info -type3">
                <div class="item">
                  <span class="tit">{{ /*이체금액*/ $t("PCOP-02-03-02-11") }}</span>
                  <span class="dec">{{ list.cncycd }} {{ $num(list.trsaccAmt) }}</span>
                </div>
                <div class="item">
                  <span class="tit">{{ /*수수료*/ $t("PCOP-02-03-02-12") }}</span>
                  <span class="dec">{{ list.cncycd }} {{ $num(list.feeAmt) }}</span>
                </div>

                <div class="item">
                  <span class="tit">{{ /*수취인 참조내용*/ $t("PCOP-02-03-02-13") }}</span>
                  <span class="dec">{{ list.draweBnkbkRepsntCtnt }}</span>
                </div>
                <div class="item">
                  <span class="tit">{{ /*송금 메모*/ $t("PCOP-02-03-02-14") }}</span>
                  <span class="dec">{{ list.rmtancMemo }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 이체 결과 End -->
      </template>
      <!-- 외화이체 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110030">
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-04-06") }}</dt>
          <dd>
            {{ RCA040FA40Response.drwotAcno }}
            {{ RCA040FA40Response.drwotAcnAls && `(${RCA040FA40Response.drwotAcnAls})` }}
          </dd>
          <dt>{{ /*이체금액*/ $t("PCOP-02-03-04-07") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvAcnCncycd }} {{ $num(RCA040FA40Response.trsaccAmt) }}</dd>
          <!--출금계좌통화와 다를경우 예상적용환율-->
          <template v-if="RCA040FA40Response.drwotAcnCncycd != RCA040FA40Response.anticiAplyExrt">
            <dt>{{ /*출금예정금액*/ $t("PCOP-02-03-04-17") }}</dt>
            <dd>{{ RCA040FA40Response.drwotAcnCncycd }} {{ $num(RCA040FA40Response.drwotzAmt) }}</dd>
            <dt>{{ /*예상적용환율*/ $t("PCOP-02-03-04-18") }}</dt>
            <dd>{{ RCA040FA40Response.anticiAplyExrt }}</dd>
          </template>
          <dt>{{ /*수수료*/ $t("PCOP-02-03-04-10") }}</dt>
          <dd>{{ RCA040FA40Response.drwotAcnCncycd }} {{ $num(RCA040FA40Response.feeAmt) }}</dd>
          <dt>{{ /*송금메모*/ $t("PCOP-02-03-04-11") }}</dt>
          <dd>{{ RCA040FA40Response.rmtancMemoCtnt }}</dd>
        </dl>
        <br />
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*입금계좌번호*/ $t("PCOP-02-03-04-13") }}</dt>
          <dd>
            {{ RCA040FA40Response.mnrcvAcno }}
            {{ RCA040FA40Response.mnrcvAcnoAls && `(${RCA040FA40Response.mnrcvAcnoAls})` }}
          </dd>
          <dt>{{ /*수취인*/ $t("PCOP-02-03-04-14") }}</dt>
          <dd>{{ RCA040FA40Response.draweFname }}</dd>
          <dt>{{ /*수취인 참조내용*/ $t("PCOP-02-03-04-15") }}</dt>
          <dd>{{ RCA040FA40Response.draweBnkbkRepsntCtnt }}</dd>
        </dl>
      </template>
      <!-- 타행이체신청 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110040">
        <div class="sub-tit">{{ /*출금정보*/ $t("PCOP-02-03-05-18") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-05-06") }}</dt>
          <dd>
            {{ RCA040FA40Response.drwotAcno }}
            {{ RCA040FA40Response.drwotAcnAls && `(${RCA040FA40Response.drwotAcnAls})` }}
          </dd>
          <dt>{{ /*이체금액*/ $t("PCOP-02-03-05-07") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvCncycd }} {{ $num(RCA040FA40Response.mnrcvTranAmt) }}</dd>
          <dt>{{ /*예상수수료*/ $t("PCOP-02-03-05-08") }}</dt>
          <dd>{{ RCA040FA40Response.drwotCncycd }} {{ $num(RCA040FA40Response.anticiFee) }}</dd>
          <dt>{{ /*송금메모*/ $t("PCOP-02-03-05-09") }}</dt>
          <dd>{{ RCA040FA40Response.rmtancMemo }}</dd>
          <template v-if="siteCode == $config.SITECODE_OGMMR">
            <dt>{{ /** 송금목적 */ $t("MPAY-02-01-23-13") }}</dt>
            <dd>{{ $t(`${RCA040FA40Response.rmtancObjctvDsticCd}_송금목적구분_MMR`) }}</dd>
          </template>
        </dl>
        <template v-if="siteCode == $config.SITECODE_OGHCM">
          <div v-html="$t('MFXD-01-02-02-08')"></div>
          <!--실제 거래 결과는 거래내역조회에서 하실 수 있습니다.-->
        </template>

        <div class="sub-tit">{{ /*입금정보*/ $t("PCOP-02-03-05-19") }}</div>
        <dl class="dlist dlist-item--type4">
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /*입금은행*/ $t("PCOP-02-03-05-11") }}</dt>
            <dd>{{ RCA040FA40Response.mnrcvOthrBnkName }}</dd>
          </template>
          <template v-if="siteCode == $config.SITECODE_OGMMR || siteCode == $config.SITECODE_OGIND">
            <dt>{{ /*입금 지점*/ $t("PCOP-02-03-05-20") }}</dt>
            <dd>{{ RCA040FA40Response.mnrcvBrnCtnt }}</dd>
          </template>
          <template v-if="siteCode == $config.SITECODE_OGIND">
            <dt>{{ /*IFSC 코드*/ $t("PCOP-02-03-05-21") }}</dt>
            <dd>{{ "IFSC Code" }}</dd>
          </template>
          <dt>{{ /*입금계좌번호*/ $t("PCOP-02-03-05-12") }}</dt>
          <dd>
            {{ RCA040FA40Response.mnrcvAcno }}
            {{ RCA040FA40Response.mnrcvAcnoAls && `(${RCA040FA40Response.mnrcvAcnoAls})` }}
          </dd>
          <dt>{{ /*수취인*/ $t("PCOP-02-03-05-13") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvAcnDpstrName }}</dd>
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /*수취인 참조내용*/ $t("PCOP-02-03-05-14") }}</dt>
            <dd>{{ RCA040FA40Response.mnrcvDraweRefCtnt }}</dd>
          </template>
          <template v-else>
            <dt>{{ /*Particulars */ $t("PCOP-02-03-06-11") }}</dt>
            <dd>{{ RCA040FA40Response.mnrcvDraweRefCtnt }}</dd>
            <dt>{{ /*수취인CODE*/ $t("PCOP-02-03-05-15") }}</dt>
            <dd>{{ RCA040FA40Response.draweCd }}</dd>
            <dt>{{ /*Reference*/ $t("PCOP-02-03-06-13") }}</dt>
            <dd>{{ RCA040FA40Response.rmark50 }}</dd>
          </template>
        </dl>
      </template>
      <!-- 타행이체신청(CBM-NET2) -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110042">
        <div class="sub-tit">{{ /*출금정보*/ $t("PCOP-02-03-05-18") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-05-06") }}</dt>
          <dd>
            {{ RCA040FA40Response.drwotAcno }}
            {{ RCA040FA40Response.drwotAcnAls && `(${RCA040FA40Response.drwotAcnAls})` }}
          </dd>
          <dt>{{ /*이체금액*/ $t("PCOP-02-03-05-07") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvCncycd }} {{ $num(RCA040FA40Response.mnrcvTranAmt) }}</dd>
          <dt>{{ /*예상수수료*/ $t("PCOP-02-03-05-08") }}</dt>
          <dd>{{ RCA040FA40Response.drwotCncycd }} {{ $num(RCA040FA40Response.anticiFee) }}</dd>
          <dt>{{ /*송금메모*/ $t("PCOP-02-03-05-09") }}</dt>
          <dd>{{ RCA040FA40Response.rmtancMemo }}</dd>
          <template v-if="siteCode == $config.SITECODE_OGMMR">
            <dt>{{ /** 송금목적 */ $t("MPAY-02-01-23-13") }}</dt>
            <dd>{{ $t(`${RCA040FA40Response.rmtancObjctvDsticCd}_송금목적구분_MMR`) }}</dd>
          </template>
        </dl>
        <template v-if="siteCode == $config.SITECODE_OGHCM">
          <div v-html="$t('MFXD-01-02-02-08')"></div>
          <!--실제 거래 결과는 거래내역조회에서 하실 수 있습니다.-->
        </template>

        <div class="sub-tit">{{ /*입금정보*/ $t("PCOP-02-03-05-19") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*입금은행*/ $t("PCOP-02-03-05-11") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvOthrBnkName }}</dd>
          <dt>{{ /*입금 지점*/ $t("PCOP-02-03-05-20") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvBrnCtnt }}</dd>
          <dt>{{ /*입금계좌번호*/ $t("PCOP-02-03-05-12") }}</dt>
          <dd>
            {{ RCA040FA40Response.mnrcvAcno }}
            {{ RCA040FA40Response.mnrcvAcnoAls && `(${RCA040FA40Response.mnrcvAcnoAls})` }}
          </dd>
          <dt>{{ /*수취인*/ $t("PCOP-02-03-05-13") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvAcnDpstrName }}</dd>
          <dt>{{ /*수취인 참조내용*/ $t("PCOP-02-03-05-14") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvDraweRefCtnt }}</dd>
        </dl>
      </template>
      <!-- 타행이체(NAPAS) -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110041">
        <div class="sub-tit">{{ /*출금정보*/ $t("PCOP-02-03-05-18") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-05-06") }}</dt>
          <dd>
            {{ RCA040FA40Response.drwotAcno }}
            {{ RCA040FA40Response.drwotAcnAls && `(${RCA040FA40Response.drwotAcnAls})` }}
          </dd>
          <dt>{{ /*이체금액*/ $t("PCOP-02-03-05-07") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvAcnCncycd }} {{ $num(RCA040FA40Response.trsaccAmt) }}</dd>
          <dt>{{ /*예상수수료*/ $t("PCOP-02-03-05-08") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvAcnCncycd }} {{ $num(RCA040FA40Response.rsultFee) }}</dd>
          <!-- <dt>{{ /*송금메모*/ $t("PCOP-02-03-05-09") }}</dt>
          <dd>{{ RCA040FA40Response.rmtancMemoCtnt }}</dd>-->
        </dl>
        <template v-if="siteCode == $config.SITECODE_OGHCM">
          <div v-html="$t('MFXD-01-02-02-08')"></div>
          <!--실제 거래 결과는 거래내역조회에서 하실 수 있습니다.-->
        </template>

        <div class="sub-tit">{{ /*입금정보*/ $t("PCOP-02-03-05-19") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ RCA040FA40Response.recvCardAcc == "2" ? /*입금계좌번호*/ $t("PCOP-02-03-05-12") : /*입금카드번호*/ $t("MPAY-02-01-18-03") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvAcno }}</dd>
          <dt>{{ /*수취인*/ $t("PCOP-02-03-05-13") }}</dt>
          <dd>{{ RCA040FA40Response.ovsesTrsaccDraweFname }}</dd>
          <dt>{{ /*수취인 참조내용*/ $t("PCOP-02-03-05-14") }}</dt>
          <dd>{{ RCA040FA40Response.draweRefCtnt }}</dd>
        </dl>
      </template>
      <!-- 자동이체등록 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110050">
        <div class="sub-tit">{{ /*출금정보*/ $t("PCOP-02-03-05-18") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-06-06") }}</dt>
          <dd>
            {{ RCA040FA40Response.drwotAcno }}
            {{ RCA040FA40Response.drwotAcnAls && `(${RCA040FA40Response.drwotAcnAls})` }}
          </dd>
          <dt>{{ /*이체금액*/ $t("PCOP-02-03-06-07") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.trsaccAmt) }}</dd>
        </dl>

        <div class="sub-tit">{{ /*입금정보*/ $t("PCOP-02-03-05-19") }}</div>
        <dl class="dlist dlist-item--type4">
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /*입금은행*/ $t("PCOP-02-03-05-11") }}</dt>
            <dd>{{ RCA040FA40Response.rcevnBnkName }}</dd>
          </template>
          <dt>{{ /*입금계좌번호*/ $t("PCOP-02-03-05-12") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvAcno }}</dd>
          <dt>{{ /*수취인*/ $t("PCOP-02-03-05-13") }}</dt>
          <dd>{{ RCA040FA40Response.draweCustnm }}</dd>
          <dt>{{ /*이체 시작일*/ $t("PCOP-02-03-06-18") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.trsaccStartYmd) }}</dd>
          <dt>{{ /*이체 종료일*/ $t("PCOP-02-03-06-19") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.trsaccEndYmd) }}</dd>
          <dt>{{ /*이체 주기*/ $t("PCOP-02-03-05-25") }}</dt>
          <dd>{{ $setTrsaccCyclDay(RCA040FA40Response.dwkDstic, RCA040FA40Response.pengagTrsaccRegiDd, RCA040FA40Response.trsaccCyclUnitDstcd, RCA040FA40Response.trsaccCyclUnit) }}</dd>
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /*휴일인 경우*/ $t("PCOP-02-03-06-16") }}</dt>
            <dd>{{ $t(`${RCA040FA40Response.holdyTrsaccDstcd}_휴일이체구분코드`) }}</dd>
          </template>
          <dt>{{ /*등록일시*/ $t("PCOP-02-03-05-26") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.aBTRegiYmd) }}</dd>
        </dl>

        <div class="sub-tit">{{ /*참조 정보*/ $t("PCOP-02-03-05-22") }}</div>
        <dl class="dlist dlist-item--type4">
          <template v-if="siteCode == $config.SITECODE_OGMMR">
            <dt>{{ /* 송금 목적 */ $t("MPAY-02-01-23-13") }}</dt>
            <dd>{{ RCA040FA40Response.trsaccApctRefCtnt1 }}</dd>
          </template>
          <dt>{{ /*particulars/수취인참조내용 */ siteCode != $config.SITECODE_OGAUC ? $t("PCOP-02-03-05-14") : $t("PCOP-02-03-06-11") }}</dt>
          <dd>{{ RCA040FA40Response.draweRefCtnt }}</dd>
          <template v-if="siteCode == $config.SITECODE_OGAUC">
            <dt>{{ /*Code*/ $t("PCOP-02-03-06-12") }}</dt>
            <dd>{{ RCA040FA40Response.draweRefCtnt2 }}</dd>
            <dt>{{ /**Reference*/ $t("PCOP-02-03-06-13") }}</dt>
            <dd>{{ RCA040FA40Response.draweRefCtnt3 }}</dd>
          </template>
        </dl>
      </template>
      <!-- 자동이체해지 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110051">
        <div class="sub-tit">{{ /*출금정보*/ $t("PCOP-02-03-05-18") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-06-06") }}</dt>
          <dd>
            {{ RCA040FA40Response.drwotAcno }}
            {{ RCA040FA40Response.drwotAcnAls && `(${RCA040FA40Response.drwotAcnAls})` }}
          </dd>
          <dt>{{ /*이체금액*/ $t("PCOP-02-03-06-07") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.trsaccAmt) }}</dd>
        </dl>
        <div class="sub-tit">{{ /*입금정보*/ $t("PCOP-02-03-05-19") }}</div>
        <dl class="dlist dlist-item--type4">
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /*입금은행*/ $t("PCOP-02-03-05-11") }}</dt>
            <dd>{{ RCA040FA40Response.rcevnBnkName }}</dd>
          </template>
          <dt>{{ /*입금계좌번호*/ $t("PCOP-02-03-05-12") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvAcno }}</dd>
          <dt>{{ /*수취인*/ $t("PCOP-02-03-05-13") }}</dt>
          <dd>{{ RCA040FA40Response.draweCustnm }}</dd>
          <dt>{{ /*이체 시작일*/ $t("PCOP-02-03-06-18") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.trsaccStartYmd) }}</dd>
          <dt>{{ /*이체 종료일*/ $t("PCOP-02-03-06-19") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.trsaccEndYmd) }}</dd>
          <dt>{{ /*이체 주기*/ $t("PCOP-02-03-05-25") }}</dt>
          <dd>{{ $setTrsaccCyclDay(RCA040FA40Response.dwkDstic, RCA040FA40Response.aBTDd, RCA040FA40Response.trsaccCyclUnitDstcd, RCA040FA40Response.trsaccCyclUnit) }}</dd>
          <!--기획엔 있으나 현재 데이터에는 존재하지 않아 미노출-->
          <!-- <dt>{{ /*휴일인 경우*/ $t("PCOP-02-03-06-16") }}</dt>
          <dd>{{$t(`${RCA040FA40Response.holdyTrsaccDstcd}_휴일이체구분코드`) }}</dd>-->
          <dt>{{ /*신청일*/ $t("PCOP-02-03-05-27") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.aBTRegiYmd) }}</dd>
          <dt>{{ /*해지일*/ $t("PCOP-02-03-05-28") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.RegiYmd) }}</dd>
        </dl>

        <div class="sub-tit">{{ /*참조 정보*/ $t("PCOP-02-03-05-19") }}</div>
        <dl class="dlist dlist-item--type4">
          <template v-if="siteCode == $config.SITECODE_OGMMR">
            <dt>{{ /* 송금 목적 */ $t("MPAY-02-01-23-13") }}</dt>
            <dd>{{ RCA040FA40Response.trsaccApctRefCtnt1 }}</dd>
          </template>
          <dt>{{ /*particulars/수취인참조내용 */ siteCode != $config.SITECODE_OGAUC ? $t("PCOP-02-03-05-14") : $t("PCOP-02-03-06-11") }}</dt>
          <dd>{{ RCA040FA40Response.draweRefCtnt }}</dd>
          <template v-if="siteCode == $config.SITECODE_OGAUC">
            <dt>{{ /*Code*/ $t("PCOP-02-03-06-12") }}</dt>
            <dd>{{ RCA040FA40Response.draweRefCtnt2 }}</dd>
            <dt>{{ /**Reference*/ $t("PCOP-02-03-06-13") }}</dt>
            <dd>{{ RCA040FA40Response.draweRefCtnt3 }}</dd>
          </template>
          <dd>{{ $getGlobalDateYmd(RCA040DA40Response.prcssFnshYMS) }}</dd>
        </dl>
      </template>
      <!-- 자동이체변경 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110052">
        <div class="sub-tit">{{ /*출금정보*/ $t("PCOP-02-03-05-18") }}</div>
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-06-06") }}</dt>
          <dd>
            {{ RCA040FA40Response.drwotAcno }}
            {{ RCA040FA40Response.drwotAcnAls && `(${RCA040FA40Response.drwotAcnAls})` }}
          </dd>
          <dt>{{ /*이체금액*/ $t("PCOP-02-03-06-07") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.trsaccAmt) }}</dd>
        </dl>

        <div class="sub-tit">{{ /*입금정보*/ $t("PCOP-02-03-05-19") }}</div>
        <dl class="dlist dlist-item--type4">
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /*입금은행*/ $t("PCOP-02-03-05-11") }}</dt>
            <dd>{{ RCA040FA40Response.rcevnBnkName }}</dd>
          </template>
          <dt>{{ /*입금계좌번호*/ $t("PCOP-02-03-05-12") }}</dt>
          <dd>{{ RCA040FA40Response.mnrcvAcno }}</dd>
          <dt>{{ /*수취인*/ $t("PCOP-02-03-05-13") }}</dt>
          <dd>{{ RCA040FA40Response.draweCustnm }}</dd>
          <dt>{{ /*이체 시작일*/ $t("PCOP-02-03-06-18") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.trsaccStartYmd) }}</dd>
          <dt>{{ /*이체 종료일*/ $t("PCOP-02-03-06-19") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.trsaccEndYmd) }}</dd>
          <dt>{{ /*이체 주기*/ $t("PCOP-02-03-05-25") }}</dt>
          <dd>{{ $setTrsaccCyclDay(RCA040FA40Response.dwkDstic, RCA040FA40Response.pengagTrsaccRegiDd, RCA040FA40Response.trsaccCyclUnitDstcd, RCA040FA40Response.trsaccCyclUnit) }}</dd>
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /*휴일인 경우*/ $t("PCOP-02-03-06-16") }}</dt>
            <dd>{{ $t(`${RCA040FA40Response.holdyTrsaccDstcd}_휴일이체구분코드`) }}</dd>
          </template>
          <dt>{{ /*등록일시*/ $t("PCOP-02-03-05-26") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.aBTRegiYmd) }}</dd>
        </dl>

        <div class="sub-tit">{{ /*참조 정보*/ $t("PCOP-02-03-05-22") }}</div>
        <dl class="dlist dlist-item--type4">
          <template v-if="siteCode == $config.SITECODE_OGMMR">
            <dt>{{ /* 송금 목적 */ $t("MPAY-02-01-23-13") }}</dt>
            <dd>{{ RCA040FA40Response.trsaccApctRefCtnt1 }}</dd>
          </template>
          <dt>{{ /*particulars/수취인참조내용 */ siteCode != $config.SITECODE_OGAUC ? $t("PCOP-02-03-05-14") : $t("PCOP-02-03-06-11") }}</dt>
          <dd>{{ RCA040FA40Response.draweRefCtnt }}</dd>
          <template v-if="siteCode == $config.SITECODE_OGAUC">
            <dt>{{ /*Code*/ $t("PCOP-02-03-06-12") }}</dt>
            <dd>{{ RCA040FA40Response.draweRefCtnt2 }}</dd>
            <dt>{{ /**Reference*/ $t("PCOP-02-03-06-13") }}</dt>
            <dd>{{ RCA040FA40Response.draweRefCtnt3 }}</dd>
          </template>
        </dl>
      </template>
      <!-- 예약이체등록 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == '110060'"></template>
      <!-- 예약이체해지 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == '110061'"></template>
      <!-- 해외송금신청 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110070 || RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110071">
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-08-06") }}</dt>
          <dd>{{ RCA040FA40Response.apctAcitmNo }}</dd>

          <dt>{{ /*송금할 외화금액*/ $t("PCOP-02-03-08-07") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.outwdRmtancAmt) }}</dd>
          <dt>{{ /*송금수수료*/ $t("PCOP-02-03-08-08") }}</dt>
          <dd>{{ RCA040FA40Response.ovsesRmtancFeeCncycd }} {{ $num(RCA040FA40Response.ovsesRmtancFeeAmt) }}</dd>
          <dt>{{ /*전신료*/ $t("PCOP-02-03-08-09") }}</dt>
          <dd>{{ RCA040FA40Response.ovsesRmtancTxfeCncycd }} {{ $num(RCA040FA40Response.ovsesRmtancTxfeAmt) }}</dd>
          <dt>{{ /*중계수수료*/ $t("PCOP-02-03-08-10") }}</dt>
          <dd>{{ $t(`${RCA040FA40Response.fXFeeBrdnDsticCd}_수수료부담구분`) }}</dd>
          <dt>{{ /*송금구분*/ $t("PCOP-02-03-08-12") }}</dt>
          <dd>{{ $t(`${RCA040FA40Response.rmtancObjctvDsticCd}_송금목적구분`) }}</dd>

          <dt>{{ /*수취 은행 BIC 코드*/ $t("PCOP-02-03-08-15") }}</dt>
          <dd>{{ RCA040FA40Response.pybnkBIC }}</dd>
          <dt>{{ /*수취 은행명*/ $t("PCOP-02-03-08-16") }}</dt>
          <dd>{{ RCA040FA40Response.pybnkName }}</dd>

          <dt>{{ /*수취 은행주소*/ $t("PCOP-02-03-08-17") }}</dt>
          <dd>{{ RCA040FA40Response.paymtBnkzAddrCtnt1 }}</dd>
          <dt>{{ /*수취 은행주소*/ $t("PCOP-02-03-08-17") }}</dt>
          <dd>{{ RCA040FA40Response.paymtBnkzAddrCtnt2 }}</dd>

          <dt>{{ /*수취은행 도시*/ $t("MFXD-02-04-01-03") }}</dt>
          <dd>{{ RCA040FA40Response.paymtBnkzAddrCtnt3 }}</dd>

          <dt>{{ /*수취 은행번호*/ $t("PCOP-02-03-08-18") }}</dt>
          <dd>{{ RCA040FA40Response.indicMatrCtnt1 }}</dd>

          <dt>{{ /*수취은행 소재지*/ $t("PCOP-02-03-08-19") }}</dt>
          <dd>{{ $t(`${RCA040FA40Response.pybnkISONatnlCd}_국가코드`) }}</dd>

          <dt>{{ /*수취인 계좌번호*/ $t("PCOP-02-03-08-20") }}</dt>
          <dd>{{ RCA040FA40Response.draweAcitmNo }}</dd>

          <dt>{{ /*수취인 성명*/ $t("PCOP-02-03-08-21") }}</dt>
          <dd>{{ RCA040FA40Response.draweCustnm }}</dd>

          <dt>{{ /*수취인 전화번호*/ $t("PCOP-02-03-08-22") }}</dt>
          <dd>{{ RCA040FA40Response.indicMatrCtnt6 }}</dd>

          <dt>{{ /*수취인 주소*/ $t("PCOP-02-03-08-23") }}</dt>
          <dd>{{ RCA040FA40Response.draweAddrCtnt1 }}</dd>

          <dt>{{ /*수취인 주소*/ $t("PCOP-02-03-08-23") }}</dt>
          <dd>{{ RCA040FA40Response.draweAddrCtnt2 }}</dd>

          <dt>{{ /*수취인 도시*/ $t("MFXD-02-04-01-01") }}</dt>
          <dd>{{ RCA040FA40Response.draweAddrCtnt3 }}</dd>

          <dt>{{ /*수취인 국가*/ $t("MFXD-02-04-01-02") }}</dt>
          <dd>{{ RCA040FA40Response.draweISONatnlCd }}</dd>

          <dt>{{ /*송금의뢰인 성명*/ $t("PCOP-02-03-08-25") }}</dt>
          <dd>{{ RCA040FA40Response.rmtrName }}</dd>
          <dt>{{ /*송금의뢰인 전화번호*/ $t("PCOP-02-03-08-26") }}</dt>
          <dd>{{ RCA040FA40Response.ovsesRmtancApctTelno }}</dd>
          <dt>{{ /*송금의뢰인 주소*/ $t("PCOP-02-03-08-27") }}</dt>
          <dd>{{ RCA040FA40Response.rmtrAddrCtnt1 }}</dd>
          <dt>{{ /*송금의뢰인 주소*/ $t("PCOP-02-03-08-27") }}</dt>
          <dd>{{ RCA040FA40Response.rmtrAddrCtnt2 }}</dd>
          <dt>{{ /*송금의뢰인 도시(영문)*/ $t("MFXD-02-04-01-05") }}</dt>
          <dd>{{ RCA040FA40Response.rmtrAddrCtnt3 }}</dd>
          <dt>{{ /*송금의뢰인 국가*/ $t("MFXD-02-04-01-06") }}</dt>
          <dd>{{ RCA040FA40Response.rmtrISONatnlCd }}</dd>

          <dt>{{ /*적요*/ $t("PCOP-02-03-08-28") }}</dt>
          <dd>{{ RCA040FA40Response.rmtancRelatdCtnt1 }}</dd>
          <dt>{{ /*적요*/ $t("PCOP-02-03-08-28") }}</dt>
          <dd>{{ RCA040FA40Response.rmtancRelatdCtnt2 }}</dd>
          <dt>{{ /*적요*/ $t("PCOP-02-03-08-28") }}</dt>
          <dd>{{ RCA040FA40Response.rmtancRelatdCtnt3 }}</dd>
          <dt>{{ /*적요*/ $t("PCOP-02-03-08-28") }}</dt>
          <dd>{{ RCA040FA40Response.rmtancRelatdCtnt4 }}</dd>
        </dl>
      </template>
      <!-- 타행대량이체신청 -->
      <template
        v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110080 || RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110081"
      >
        <dl class="dlist dlist-item--type4">
          <dt>{{ $t(/*출금계좌번호*/ "PCOP-02-03-03-06") }}</dt>
          <dd>{{ RCA040FA40Response.dataGrid[0].drwotAcno }}</dd>
          <dt>{{ /*총 이체금액*/ $t("PCOP-02-03-03-07") }}</dt>
          <dd>{{ RCA040FA40Response.currencyCode }} {{ $num(RCA040FA40Response.dTotalTrsaccAmt) }}</dd>
          <dt>{{ /*수수료*/ $t("PCOP-02-03-03-08") }}</dt>
          <dd>{{ RCA040FA40Response.currencyCode }} {{ $num(RCA040FA40Response.dTotalFeeAmt) }}</dd>
        </dl>
        <div class="sub-tit">{{ /*이체결과*/ $t("PCOP-02-03-03-09") }}</div>
        <!-- 이체 결과 부분-->
        <template v-for="(list, index) in RCA040FA40Response.dataGrid">
          <div class="box-white -type4" :key="index">
            <div class="header">
              <div class="title">
                {{ list.mnrcvAcno }}({{ list.cncycd }})
                <!--처리 상태-->
                <template v-if="list.corpBsacRiStusDstcd == '1' && list.prcssStusDstcd == '1'">
                  <template
                    v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110081"
                  >
                    <div
                      class="state normal"
                      v-if="'0|1|2|3|4|5|A'.includes(RBF1605T41Response.untcTrsaccPrgrsDstcd)"
                    >{{ $t(`${RBF1605T41Response.untcTrsaccPrgrsDstcd}_otrQtStat`) }}</div>
                    <div
                      class="state warning"
                      v-else
                    >{{ $t(`${RBF1605T41Response.untcTrsaccPrgrsDstcd}_otrQtStat`) }}</div>
                  </template>
                  <template v-else>
                    <template v-if="list.iBTelgmPrcssRsultCd == '0000'">
                      <div class="state normal">{{ /*정상*/ $t("PCOP-02-03-03-10") }}</div>
                    </template>
                    <template v-else>
                      <div class="state warning">{{ /*실패*/ $t("PCOP-02-03-03-16") }}</div>
                    </template>
                  </template>
                </template>
                <!--처리상태 END-->
              </div>
              <div class="desc">
                <div class="item account">{{ list.draweCustnm }}</div>
              </div>
            </div>
            <div class="content">
              <div class="account-info -type3">
                <div class="item">
                  <span class="tit">{{ $t(/*은행명*/ "PCOP-02-03-03-11") }}</span>
                  <span class="dec">{{ list.mnrcvOthrBnkName }}</span>
                </div>
                <div class="item">
                  <span class="tit">{{ /*이체금액*/ $t("PCOP-02-03-03-12") }}</span>
                  <span class="dec">{{ list.cncycd }} {{ $num(list.trsaccAmt) }}</span>
                </div>
                <div class="item">
                  <span class="tit">{{ /*수수료*/ $t("PCOP-02-03-03-13") }}</span>
                  <span class="dec">{{ list.cncycd }} {{ $num(list.feeAmt) }}</span>
                </div>

                <div class="item">
                  <span class="tit">{{ /*수취인 참조내용*/ $t("PCOP-02-03-03-14") }}</span>
                  <span class="dec">{{ list.draweBnkbkRepsntCtnt }}</span>
                </div>
                <div class="item">
                  <span class="tit">{{ /*송금 메모*/ $t("PCOP-02-03-03-15") }}</span>
                  <span class="dec">{{ list.rmtancMemo }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 이체 결과 End -->
      </template>
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110082">
        <dl class="dlist dlist-item--type4">
          <dt>{{ $t(/*출금계좌번호*/ "PCOP-02-03-03-06") }}</dt>
          <dd>{{ RCA040FA40Response.dataGrid[0].drwotAcno }}</dd>
          <dt>{{ /*총 이체금액*/ $t("MCOM-0000201") }}</dt>
          <dd>
            MMK
            {{
              $num(
                _.map(RCA040FA40Response.dataGrid, v => {
                  const trsaccAmt = v.trsaccAmt;
                  return trsaccAmt;
                }).reduce((a, b) => a + b, 0),
              )
            }}
          </dd>
          <dt>{{ /*총 이체 수수료*/ $t("MCOM-0000202") }}</dt>
          <dd>
            MMK
            {{
              $num(
                _.map(RCA040FA40Response.dataGrid, v => {
                  const feeAmt = v.feeAmt;
                  return feeAmt;
                }).reduce((a, b) => a + b, 0),
              )
            }}
          </dd>
          <dt>{{ /*총 건수*/ $t("MCOM-0000200") }}</dt>
          <dd>{{ $num(RCA040FA40Response.totalLineCnt, 0) }}</dd>
          <dt>{{ /*이체일*/ $t("MCOM-0000204") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.dataGrid[0].salryDate) }}</dd>
          <dt v-if="RCA040DA40Response.lastPrcssStusDstcd == '20' && 'salryTrsaccMgtNo' in this.RCA040FA40Response.dataGrid[0]">{{ /*급여이체 관리번호*/ $t("MCOM-0000203") }}</dt>
          <dd v-if="RCA040DA40Response.lastPrcssStusDstcd == '20' && 'salryTrsaccMgtNo' in this.RCA040FA40Response.dataGrid[0]">
            {{ RCA040FA40Response.dataGrid[0].salryTrsaccMgtNo }}
          </dd>
        </dl>
        <div class="sub-tit">{{ /*이체결과*/ $t("PCOP-02-03-03-09") }}</div>
        <!-- 이체 결과 부분-->
        <template v-for="(list, index) in RCA040FA40Response.dataGrid">
          <div class="box-white -type4" :key="index">
            <div class="header">
              <div class="title">
                {{ list.mnrcvAcno }}({{ list.cncycd }})
                <!--처리 상태-->
                <template v-if="list.corpBsacRiStusDstcd == '1' && list.prcssStusDstcd == '1'">
                  <template v-if="RCA040DA40Response.lastPrcssStusDstcd == '20'">
                    <template v-if="!_.isEmpty(RBF1605T41Response)">
                      <div class="state normal" v-if="'0|1|2|4'.includes(RBF1605T41Response.gridDtail[index].brncoSalryTranStusDstcd)">
                        {{ $t(`${RBF1605T41Response.gridDtail[index].brncoSalryTranStusDstcd}_mmrSalary`) }}
                      </div>
                      <div class="state warning" v-else-if="'3|9'.includes(RBF1605T41Response.gridDtail[index].brncoSalryTranStusDstcd)">
                        {{ $t(`${RBF1605T41Response.gridDtail[index].brncoSalryTranStusDstcd}_mmrSalary`) }}
                      </div>
                    </template>
                    <template v-else>
                      <div class="state warning">
                        {{ /*오류*/ $t("PCOP-02-03-03-18") }}
                      </div>
                    </template>
                  </template>
                </template>
                <!--처리상태 END-->
              </div>
              <div class="desc">
                <div class="item account">{{ list.ovsesCustOcntryName }}</div>
              </div>
            </div>
            <div class="content">
              <div class="account-info -type3">
                <div class="item">
                  <span class="tit">{{ $t(/*은행명*/ "PCOP-02-03-03-11") }}</span>
                  <span class="dec">{{ list.bnkName }}</span>
                </div>
                <div class="item">
                  <span class="tit">{{ /*이체금액*/ $t("PCOP-02-03-03-12") }}</span>
                  <span class="dec">{{ list.cncycd }} {{ $num(list.trsaccAmt) }}</span>
                </div>
                <div class="item">
                  <span class="tit">{{ /*수수료*/ $t("PCOP-02-03-03-13") }}</span>
                  <span class="dec" v-if="list.feeAmt != null">{{ list.cncycd }} {{ $num(list.feeAmt) }}</span>
                  <span class="dec" v-else>{{ list.cncycd }} {{ $num(0) }}</span>
                </div>

                <div class="item">
                  <span class="tit">{{ /*비고*/ $t("MPAY-02-01-25-13") }}</span>
                  <span class="dec">{{ list.inotBasiSumryCtnt }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 이체 결과 End -->
      </template>
      <!-- 예금해지/갱신 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_120010">
        <template v-if="RCA040FA40Response.dpostTermiUpdatDstcd == '1' /*해지*/">
          <dl class="dlist dlist-item--type4">
            <dt>{{ $t(/*해지계좌번호*/ "MDEP-02-01-10-04") }}</dt>
            <dd>{{ RCA040FA40Response.termiUpdatAcno }}</dd>
            <dt>{{ $t(/*해지계좌명*/ "MDEP-02-01-10-05") }}</dt>
            <dd>{{ RCA040FA40Response.termiUpdatAcnName }}</dd>
            <dt>{{ $t(/*해지일*/ "MDEP-02-01-10-06") }}</dt>
            <dd>{{ $getGlobalDateFmt(RCA040FA40Response.termiYmd) }}</dd>

            <dt>{{ $t(/*해지구분*/ "MDEP-02-01-10-19") }}</dt>
            <dd>{{ $t(`${RCA040FA40Response.termiTimgDstcd}_해지시기구분코드`) }}</dd>

            <dt>{{ $t(/*원금*/ "MDEP-01-01-07-09") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.prcpl) }}</dd>
            <dt>{{ $t(/*이자*/ "MDEP-01-01-07-10") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.intAmt) }}</dd>

            <dt>{{ $t(/*징수세금*/ "MDEP-01-01-07-11") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.levyTax) }}</dd>
            <dt>{{ $t(/*총지급금액*/ "PCOP-02-03-09-18") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.totalzPaymtAmt) }}</dd>
            <template v-if="RCA040FA40Response.mnrcvAcnCncycd != RCA040FA40Response.cncycd">
              <dt>{{ $t(/*예상입금금액*/ "PCOP-02-03-09-30") }}</dt>
              <dd>{{ RCA040FA40Response.mnrcvAcnCncycd }} {{ $num(RCA040FA40Response.anticiMrvamt) }}</dd>
              <dt>{{ $t(/*예상적용환율*/ "PCOP-02-03-09-27") }}</dt>
              <dd>{{ RCA040FA40Response.anticiAplyExrt }}</dd>
              <dt>{{ $t(/*예상수수료*/ "PCOP-02-03-09-28") }}</dt>
              <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.anticiFee) }}</dd>
            </template>
            <dt>{{ $t(/*입금계좌번호*/ "MPAY-02-01-25-09") }}</dt>
            <dd>{{ RCA040FA40Response.mnrcvAcno }}</dd>
          </dl>
        </template>
        <template v-else>
          <!-- 만기지급 공통항목확인 -->
          \
          <dl class="dlist dlist-item--type4">
            <dt>{{ $t(/*갱신계좌번호*/ "PCOP-02-03-09-07") }}</dt>
            <dd>{{ RCA040FA40Response.termiUpdatAcno }}</dd>
            <dt>{{ $t(/*갱신계좌명*/ "PCOP-02-03-09-08") }}</dt>
            <dd>{{ RCA040FA40Response.termiUpdatAcnName }}</dd>

            <dt>{{ $t(/*재예치구분*/ "PCOP-02-03-09-10") }}</dt>
            <dd>
              <template
                v-if="RCA040FA40Response.expirExtenTagetDstcd == '1'"
              >{{ $t(/*원금만예치*/ "PCOP-02-03-09-15") }}</template>
              <template
                v-else-if="RCA040FA40Response.expirExtenTagetDstcd == '2'"
              >{{ $t(/*원금 + 이자예치*/ "MDEP-02-01-13-16") }}</template>
            </dd>
            <dt>{{ $t(/*재예치기간*/ "MDEP-02-01-13-07") }}({{ $t(`${RCA040FA40Response.brncoCyclDstcd}_BO주기구분코드`) }})</dt>
            <dd>{{ RCA040FA40Response.ctrcTrmCnt }}</dd>
            <dt>{{ $t(/*이자지급방법*/ "PCOP-02-03-09-13") }}</dt>
            <dd>{{ $t(`${RCA040FA40Response.dpostIntPaymtDstcd}_이자지급방식`) }}</dd>
            <dt>{{ $t(/*원금*/ "MDEP-01-01-07-09") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.prcpl) }}</dd>
            <dt>{{ $t(/*이자*/ "MDEP-01-01-07-10") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.intAmt) }}</dd>
            <dt>{{ $t(/*징수세금*/ "MDEP-01-01-07-11") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.levyTax) }}</dd>
            <dt>{{ $t(/*총지급금액*/ "PCOP-02-03-09-18") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.totalzPaymtAmt) }}</dd>

            <dt>{{ $t(/*재예치금액*/ "PCOP-02-03-09-20") }}</dt>
            <dd>{{ $num(RCA040FA40Response.reDtmnAmt) }}</dd>
            <dt>{{ $t(/*갱신일*/ "PCOP-02-03-09-21") }}</dt>
            <dd>{{ $getGlobalDateFmt(RCA040FA40Response.updatYmd) }}</dd>

            <dt>{{ $t(/*만기일*/ "PCOP-02-03-09-22") }}</dt>
            <dd>{{ $getGlobalDateFmt(RCA040FA40Response.expirYmd) }}</dd>
            <dt>{{ $t(/*적용이율*/ "PCOP-02-03-09-23") }}</dt>
            <dd>{{ $num(RCA040FA40Response.updatAplyIrt) }}%</dd>

            <template v-if="RCA040FA40Response.expirExtenTagetDstcd == '1'">
              <dt>{{ $t(/*이자입금금액*/ "PCOP-02-03-09-31") }}</dt>
              <dd>{{ RCA040FA40Response.mnrcvAcnCncycd }} {{ $num(RCA040FA40Response.paymtIntAmt) }}</dd>
              <dt>{{ $t(/*이자입금계좌번호*/ "PCOP-02-03-09-25") }}</dt>
              <dd>{{ RCA040FA40Response.mnrcvAcno }}</dd>
              <dt>{{ $t(/*예상이자입금금액*/ "PCOP-02-03-09-26") }}</dt>
              <dd>{{ RCA040FA40Response.mnrcvAcnCncycd }} {{ $num(RCA040FA40Response.anticiIntMrvamt) }}</dd>
              <dt>{{ $t(/*예상적용환율*/ "PCOP-02-03-09-27") }}</dt>
              <dd>{{ RCA040FA40Response.anticiAplyExrt }}</dd>
              <dt>{{ $t(/*예상수수료*/ "PCOP-02-03-09-28") }}</dt>
              <dd>{{ RCA040FA40Response.mnrcvAcnCncycd }} {{ $num(RCA040FA40Response.anticiFee) }}</dd>
            </template>
          </dl>
        </template>
      </template>
      <!-- 예상조회/대출금상환 -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_130010">
        <dl class="dlist dlist-item--type4">
          <dt>{{ $t(/*대출계좌번호*/ "MLON-01-01-11-03") }}</dt>
          <dd>{{ RCA040FA40Response.lnAcno }}</dd>
          <dt>{{ $t(/*출금계좌번호*/ "MLON-01-01-11-04") }}</dt>
          <dd>{{ RCA040FA40Response.drwotAcno }}</dd>
          <dt>{{ $t(/*예금주명*/ "MLON-01-01-11-05") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.lnAcnDpstrName) }}</dd>
          <dt>{{ $t(/*상환일*/ "MLON-01-01-14-03") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.rpayYmd) }}</dd>
          <dt>{{ $t(/*거래종류*/ "PCOP-01-01-02-03") }}</dt>
          <dd>{{ $t(`${RCA040FA40Response.brncoAcitmTranIdnfiPtrnDstcd}_BO계정거래식별유형`) }}</dd>
          <dt>{{ $t(/*총상환금액*/ "MLON-01-01-14-08") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.rpayTotalzAmt) }}</dd>

          <dt>{{ $t(/*원금*/ "MLON-01-01-04-05") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.rpayPrcplAmt) }}</dd>
          <dt>{{ $t(/*약정이자*/ "MLON-01-01-04-06") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.totalzPaymtAmt) }}</dd>
          <dt>{{ $t(/*연체이자*/ "MLON-01-01-04-07") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.rpayzInt) }}</dd>
          <dt>{{ $t(/*환급이자*/ "MLON-01-01-15-06") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.mnyrtnInt) }}</dd>

          <dt>{{ $t(/*조기상환수수료*/ "MLON-01-01-15-07") }}</dt>
          <dd>{{ RCA040FA40Response.lnCncycd }} {{ $num(RCA040FA40Response.elyRpayFee) }}</dd>
          <dt>{{ $t(/*대출잔액*/ "MLON-01-01-15-08") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.lnBal) }}</dd>

          <dt>{{ $t(/*대출이율*/ "MINQ-01-01-10-14") }}</dt>
          <dd>{{ RCA040FA40Response.ovsesInln }}%</dd>
          <template v-if="RCA040FA40Response.cncycd != RCA040FA40Response.lnCncycd">
            <dt>{{ $t(/*예상출금금액*/ "MPAY-02-01-25-18") }}</dt>
            <dd>{{ RCA040FA40Response.lnCncycd }} {{ RCA040FA40Response.anticiDrwotAmt }}</dd>
            <dt>{{ $t(/*예상적용환율*/ "PCOP-02-03-04-09") }}</dt>
            <dd>{{ RCA040FA40Response.anticiAplyExrt }}</dd>
            <dt>{{ $t(/*예상수수료*/ "PCOP-02-03-09-28") }}</dt>
            <dd>{{ RCA040FA40Response.lnCncycd }} {{ RCA040FA40Response.anticiFee }}</dd>
          </template>

          <dt>{{ $t(/*이자계산시작일*/ "MLON-01-01-10-15") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.intCalcStartYmd) }}</dd>
          <dt>{{ $t(/*이자계산종료일*/ "MLON-01-01-10-16") }}</dt>
          <dd>{{ $getGlobalDateFmt(RCA040FA40Response.intCalcEndYmd) }}</dd>
        </dl>
      </template>
      <!-- PhoneTopup -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110011">
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-03-06") }}</dt>
          <dd>{{ RCA040FA40Response.drwotAcno }} ({{ RCA040FA40Response.drwotAcnAls }})</dd>
          <dt>{{ /*총 결제금액*/ $t("MPAY-06-01-01-56") }}</dt>
          <dd>{{ RCA040FA40Response.drwotCncycd }} {{ $num(RCA040FA40Response.chrgAmt) }}</dd>
          <dt>{{ /*서비스 구분*/ $t("MPAY-06-01-01-57") }}</dt>
          <dd>{{ /*휴대폰 요금충전*/ $t("MPAY-06-01-01-07") }}</dd>
          <dt>{{ /*휴대폰번호*/ $t("MPAY-06-01-01-44") }}</dt>
          <dd>{{ RCA040FA40Response.cphnNo }}</dd>
          <dt>{{ /*통신사*/ $t("MPAY-06-01-01-45") }}</dt>
          <dd>{{ RCA040FA40Response.telcmNm }}</dd>
        </dl>
      </template>
      <!-- BillPayment -->
      <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110012">
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*서비스 구분*/ $t("MPAY-06-01-01-57") }}</dt>
          <dd>{{ RCA040FA40Response.paymtDsticCd == 1 ? $t("MPAY-06-01-01-18") : $t("MPAY-06-01-01-21") }}</dd>
          <dt>{{ /*출금계좌번호*/ $t("PCOP-02-03-03-06") }}</dt>
          <dd>{{ RCA040FA40Response.drwotAcno }} ({{ RCA040FA40Response.drwotAcnAls }})</dd>
          <template v-if="this.RCA040FA40Response.paymtDsticCd == 2">
            <!-- 수도요금일 때만 보임 -->
            <dt>{{ /*결제금액*/ $t("MPAY-06-01-01-54") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.paymtAmt) }}</dd>
            <dt>{{ /*수수료*/ $t("MPAY-06-01-01-55") }}</dt>
            <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.fee) }}</dd>
          </template>
          <dt>{{ /*총 결제금액*/ $t("MPAY-06-01-01-56") }}</dt>
          <dd>{{ RCA040FA40Response.cncycd }} {{ $num(RCA040FA40Response.totalPaymtAmt) }}</dd>
          <dt>{{ /*서비스 제공업체*/ $t("MPAY-06-01-01-58") }}</dt>
          <dd>{{ RCA040FA40Response.paymtInstiName }}</dd>
          <dt>{{ /*납부자코드*/ $t("MPAY-06-01-01-32") }}</dt>
          <dd>{{ RCA040FA40Response.prCd }}</dd>
          <dt>{{ /*고객명*/ $t("MPAY-06-01-01-60") }}</dt>
          <dd>{{ RCA040FA40Response.custnm }}</dd>
          <dt>{{ /*청구월*/ $t("MPAY-06-01-01-62") }}</dt>
          <dd>{{ RCA040FA40Response.askCycl }}</dd>
        </dl>
      </template>
      <!-- 사용자등록관리, 결재단계설정/수정 -->
      <template
        v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_140001 || RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_140002 || RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_140003 || RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_140004"
      >
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*사용자명*/ $t("MOTP-FRT-03-01-01-24") }}</dt>
          <dd>{{ RCA040FA40Response.userName }}</dd>
          <dt>{{ /*사용자 ID*/ $t("EKYC-15-04") }}</dt>
          <dd>{{ RCA040FA40Response.uid }}</dd>
          <dt>{{ /*직급 및 기타 정보*/ $t("PCOP-02-03-03-19") }}</dt>
          <dd>{{ RCA040FA40Response.rmark }}</dd>
          <dt>{{ /*등록할 OTP일련번호*/ $t("PCOP-02-03-03-20") }}</dt>
          <dd>{{ RCA040FA40Response.otpSerno }}</dd>
        </dl>
      </template>
      <!-- 사용자별 보안매체관리 해제/등록/변경 -->
      <template
        v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_140005 || RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_140006"
      >
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*사용자명*/ $t("MOTP-FRT-03-01-01-24") }}</dt>
          <dd>{{ RCA040FA40Response.userName }}</dd>
          <dt>{{ /*사용자 ID*/ $t("EKYC-15-04") }}</dt>
          <dd>{{ RCA040FA40Response.uid }}</dd>
          <dt>{{ /*직급 및 기타 정보*/ $t("PCOP-02-03-03-19") }}</dt>
          <dd>{{ RCA040FA40Response.rmark }}</dd>
          <dt>{{ /*기존 OTP 종류*/ $t("PCOP-02-03-03-21") }}</dt>
          <dd
            v-if="RCA040FA40Response.otpVndrDsticCd!=='' && RCA040FA40Response.deleteOtpVndrDsticCd!==''"
          >{{RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_140005 ? $t(`${RCA040FA40Response.otpVndrDsticCd}_OTP밴더구분코드`) : $t(`${RCA040FA40Response.deleteOtpVndrDsticCd}_OTP밴더구분코드`)}}</dd>
          <dd v-else>-</dd>
          <dt>{{ /*기존 OTP 일련번호*/ $t("PCOP-02-03-03-22") }}</dt>
          <dd
            v-if="RCA040FA40Response.otpSerno!=='' && RCA040FA40Response.deleteOtpSerno!==''"
          >{{RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_140005 ? RCA040FA40Response.otpSerno : RCA040FA40Response.deleteOtpSerno}}</dd>
          <dd v-else>-</dd>
        </dl>
      </template>
    </div>
  </div>
</template>
<script>
import { aprvalParam } from "@/mixins/approval";
import { mapFields } from "vuex-map-fields";
export default {
  mixins: [aprvalParam],
  computed: {
    ...mapFields("admin/approvalInfo", ["approvalSearch", "approvalInfo", "RCA040DA40Response", "RCA040FA40Response", "RBF1605T41Response"]),
    ...mapFields(["siteCode"]),
  },
  mounted() {},
  data() {
    return {
      show4: true,
    };
  },
};
</script>
